import React, { useState, useEffect } from 'react';
import './CategoryManager.css';
import { getCategories, saveCategories } from '../../firebase/dataService';

function CategoryManager() {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);

  // تحميل التصنيفات من Firebase عند بدء المكون
  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      setLoading(true);
      const cats = await getCategories();
      setCategories(cats);
    } catch (error) {
      console.error('Error loading categories:', error);
      showNotification('حدث خطأ في تحميل التصنيفات', 'error');
    } finally {
      setLoading(false);
    }
  };

  const saveCategoriesData = async (newCategories) => {
    try {
      await saveCategories(newCategories);
      setCategories(newCategories);
    } catch (error) {
      console.error('Error saving categories:', error);
      showNotification('حدث خطأ في حفظ التصنيفات', 'error');
      throw error;
    }
  };

  const handleAddCategory = async () => {
    if (newCategory.trim() && !categories.includes(newCategory.trim())) {
      const newCategories = [...categories, newCategory.trim()];
      await saveCategoriesData(newCategories);
      setNewCategory('');
      showNotification('تم إضافة التصنيف بنجاح', 'success');
    } else if (categories.includes(newCategory.trim())) {
      showNotification('هذا التصنيف موجود بالفعل', 'error');
    }
  };

  const handleDeleteCategory = (index) => {
    setCategoryToDelete(index);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (categoryToDelete !== null) {
      const newCategories = categories.filter((_, i) => i !== categoryToDelete);
      await saveCategoriesData(newCategories);
      showNotification('تم حذف التصنيف بنجاح', 'success');
      setShowDeleteModal(false);
      setCategoryToDelete(null);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setCategoryToDelete(null);
  };

  const handleEditCategory = (index) => {
    setEditingIndex(index);
    setEditValue(categories[index]);
  };

  const handleSaveEdit = async (index) => {
    if (editValue.trim() && !categories.includes(editValue.trim())) {
      const newCategories = [...categories];
      newCategories[index] = editValue.trim();
      await saveCategoriesData(newCategories);
      setEditingIndex(null);
      setEditValue('');
      showNotification('تم تعديل التصنيف بنجاح', 'success');
    } else if (categories.includes(editValue.trim()) && editValue.trim() !== categories[index]) {
      showNotification('هذا التصنيف موجود بالفعل', 'error');
    }
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditValue('');
  };

  const handleMoveUp = async (index) => {
    if (index > 0) {
      const newCategories = [...categories];
      [newCategories[index - 1], newCategories[index]] = [newCategories[index], newCategories[index - 1]];
      await saveCategoriesData(newCategories);
      showNotification('تم تحريك التصنيف للأعلى', 'success');
    }
  };

  const handleMoveDown = async (index) => {
    if (index < categories.length - 1) {
      const newCategories = [...categories];
      [newCategories[index], newCategories[index + 1]] = [newCategories[index + 1], newCategories[index]];
      await saveCategoriesData(newCategories);
      showNotification('تم تحريك التصنيف للأسفل', 'success');
    }
  };

  const showNotification = (message, type = 'success') => {
    const notification = document.createElement('div');
    notification.className = `admin-notification ${type}`;
    notification.innerHTML = `
      <div class="notification-content">
        <span class="notification-icon">${type === 'success' ? '✅' : '❌'}</span>
        <span class="notification-message">${message}</span>
      </div>
    `;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.add('show');
    }, 10);
    
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  };

  return (
    <div className="category-manager">
      <div className="category-header">
        <h2>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '8px' }}>
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
            <line x1="7" y1="7" x2="7.01" y2="7"></line>
          </svg>
          إدارة التصنيفات
        </h2>
        <p className="category-subtitle">إضافة وتعديل وحذف التصنيفات المتاحة في الموقع</p>
      </div>

      <div className="add-category-section">
        <h3>إضافة تصنيف جديد</h3>
        <div className="add-category-form">
          <input
            type="text"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            placeholder="اسم التصنيف الجديد"
            onKeyPress={(e) => e.key === 'Enter' && handleAddCategory()}
          />
          <button onClick={handleAddCategory} className="add-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '4px' }}>
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            إضافة
          </button>
        </div>
      </div>

      <div className="categories-list-section">
        <h3>التصنيفات الحالية ({categories.length})</h3>
        <div className="categories-grid">
          {categories.map((category, index) => (
            <div key={index} className="category-card">
              <button
                className="category-delete-x"
                onClick={() => handleDeleteCategory(index)}
                title="حذف التصنيف"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
              {editingIndex === index ? (
                <div className="edit-mode">
                  <input
                    type="text"
                    value={editValue}
                    onChange={(e) => setEditValue(e.target.value)}
                    className="edit-input"
                    autoFocus
                  />
                  <div className="edit-actions">
                    <button onClick={() => handleSaveEdit(index)} className="save-btn">
                      ✅
                    </button>
                    <button onClick={handleCancelEdit} className="cancel-btn">
                      ❌
                    </button>
                  </div>
                </div>
              ) : (
                <div className="view-mode">
                  <div className="category-order-controls">
                    <button
                      onClick={() => handleMoveUp(index)}
                      className="move-btn"
                      disabled={index === 0}
                      title="تحريك للأعلى"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="12" y1="19" x2="12" y2="5"></line>
                        <polyline points="5 12 12 5 19 12"></polyline>
                      </svg>
                    </button>
                    <button
                      onClick={() => handleMoveDown(index)}
                      className="move-btn"
                      disabled={index === categories.length - 1}
                      title="تحريك للأسفل"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <polyline points="19 12 12 19 5 12"></polyline>
                      </svg>
                    </button>
                  </div>
                  <span className="category-name">
                    <span className="category-number">{index + 1}.</span>
                    {category}
                  </span>
                  <div className="category-actions">
                    <button
                      onClick={() => handleEditCategory(index)}
                      className="edit-btn"
                      title="تعديل"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* نافذة تأكيد الحذف */}
      {showDeleteModal && (
        <div className="delete-modal-overlay" onClick={cancelDelete}>
          <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
            <div className="delete-modal-icon">⚠️</div>
            <h3 className="delete-modal-title">تأكيد الحذف</h3>
            <p className="delete-modal-message">
              هل أنت متأكد من حذف التصنيف <strong>"{categoryToDelete !== null ? categories[categoryToDelete] : ''}"</strong>؟
            </p>
            <p className="delete-modal-warning">
              ⚠️ هذا الإجراء لا يمكن التراجع عنه
            </p>
            <div className="delete-modal-actions">
              <button className="delete-modal-cancel" onClick={cancelDelete}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '4px' }}>
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
                إلغاء
              </button>
              <button className="delete-modal-confirm" onClick={confirmDelete}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginLeft: '4px' }}>
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                </svg>
                حذف نهائياً
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CategoryManager;
